import React, { Component } from 'react';
import {Helmet} from 'react-helmet';

class Partner extends Component {

  render() {
    return (
        <div className="page partner" id="page">
          <Helmet>
            <title>rewardeclub | Businesses find its easy to reach customers.</title>
            <meta http-equiv="Content-Type" content="text/html; charset=utf-8"/>
            <meta name="description" content="Business partners reach their customers constantly via rewardeclub to win them back." />
            <meta name="keywords" content="eclub, e-club, customer eclub, customer e-club, customers eclub, customers e-club, manage eclub, eclub management, manage e-club, e-club management, connect business and customers" />
            <meta name="robots" content="index, follow" />
          </Helmet>
          Business partners reach their customers constantly via <b>rewardeclub</b> to win them back;
          they also reach potential customers without any additonal effort.
          <p/>
          <div className="box-1">
            <div className="box-heading">How does it work for Business partners?</div>
            <div className="box-body">
            1. Sign up your business on rewardeclub<p />
            2. Add rewardeclub customer sign up link to your website<p />
            3. That's it. Notice your customers return with rewardeclub discount.<p />
            4. Optionally, track your cutomer traffic from rewardeclub. 
            </div>
          </div>
        </div>
    );
  }
}

export default Partner;



// WEBPACK FOOTER //
// ./src/page/Partner.js